<template>
    <div class="doc-ruler" :style="{ width: `${widthPx}px` }" aria-hidden="true">
        <div class="doc-ruler__margin" :style="{ width: `${marginLeftPx}px` }"></div>
        <div class="doc-ruler__margin doc-ruler__margin--right" :style="{ width: `${marginRightPx}px` }"></div>
        <span v-for="tick in ticks" :key="tick.cm" class="doc-ruler__tick" :class="{ 'doc-ruler__tick--major': tick.major }" :style="{ left: `${tick.left}px` }">
            <span v-if="tick.label" class="doc-ruler__label">{{ tick.label }}</span>
        </span>
        <!-- Recuo da primeira linha (triangulo de cima) -->
        <span class="doc-ruler__marker doc-ruler__marker--first" :style="{ left: `${markerLeft(firstLineCm + leftCm)}px` }"
            title="Recuo da primeira linha" @mousedown.prevent="startDrag('firstLine', $event)"></span>
        <!-- Recuo esquerdo (triangulo de baixo) -->
        <span class="doc-ruler__marker doc-ruler__marker--left" :style="{ left: `${markerLeft(leftCm)}px` }"
            title="Recuo esquerdo" @mousedown.prevent="startDrag('left', $event)"></span>
    </div>
</template>

<script>
import { CM_TO_PX, PAGE } from "./brand";

// Regua horizontal da folha: mostra os centimetros a partir da margem e os
// marcadores de recuo do paragrafo atual, arrastaveis (passo de 0,25 cm).
export default {
    name: "EditorRuler",
    props: {
        zoom: { type: Number, default: 1 },
        pageWidthCm: { type: Number, default: PAGE.widthCm },
        marginLeft: { type: Number, default: 1.5 },
        marginRight: { type: Number, default: 1.5 },
        leftCm: { type: Number, default: 0 },
        firstLineCm: { type: Number, default: 0 },
    },
    data: () => ({ drag: null }),
    computed: {
        scale() {
            return CM_TO_PX * this.zoom;
        },
        widthPx() {
            return this.pageWidthCm * this.scale;
        },
        marginLeftPx() {
            return this.marginLeft * this.scale;
        },
        marginRightPx() {
            return this.marginRight * this.scale;
        },
        textWidthCm() {
            return this.pageWidthCm - this.marginLeft - this.marginRight;
        },
        ticks() {
            const ticks = [];
            for (let half = 0; half <= Math.floor(this.textWidthCm * 2); half += 1) {
                const value = half / 2;
                ticks.push({ cm: value, major: half % 2 === 0, label: half % 2 === 0 && value > 0 ? String(value) : "", left: this.marginLeftPx + value * this.scale });
            }
            return ticks;
        },
    },
    beforeDestroy() {
        this.stopDrag();
    },
    methods: {
        markerLeft(valueCm) {
            return this.marginLeftPx + Math.max(0, valueCm) * this.scale;
        },
        startDrag(kind, event) {
            this.drag = { kind, rect: this.$el.getBoundingClientRect() };
            window.addEventListener("mousemove", this.onDrag);
            window.addEventListener("mouseup", this.stopDrag);
            this.onDrag(event);
        },
        onDrag(event) {
            if (!this.drag) return;
            const raw = (event.clientX - this.drag.rect.left - this.marginLeftPx) / this.scale;
            const snapped = Math.round(Math.min(this.textWidthCm - 1, Math.max(0, raw)) * 4) / 4;
            if (this.drag.kind === "left") {
                // Mover o recuo esquerdo leva a primeira linha junto (como no Word).
                this.$emit("change", { left: snapped, firstLine: this.firstLineCm });
            } else {
                this.$emit("change", { left: this.leftCm, firstLine: Math.round((snapped - this.leftCm) * 4) / 4 });
            }
        },
        stopDrag() {
            this.drag = null;
            window.removeEventListener("mousemove", this.onDrag);
            window.removeEventListener("mouseup", this.stopDrag);
        },
    },
};
</script>
